import React, { useState } from "react";
import axios from "axios";

const usePageManagement = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    let mainAPI = "/dynamicWebsite/backend/page";
    const [data, setData] = useState([]);
    const getPageManagementData = (params, frontend) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get(frontend ? '/dynamicWebsite/frontend/page' : mainAPI, {
                params: params,
            })
            .then((response) => {
                let data = response.data || [];
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                }
            });
    };
    const getPageManagementSelfData = (params, frontend) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get('/brand_website/page_self', {
                params: params,
            })
            .then((response) => {
                let data = response.data || [];
                setData(data?.data);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            })
            .catch((error) => {
                if (!axios.isCancel(error)) {
                }
            });
    };
    const postPageManagementData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainAPI, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchPageManagementData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(mainAPI, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deletePageManagementData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainAPI, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "success") {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    return {
        PageManagementData: data,
        getPageManagementData,
        getPageManagementSelfData,
        postPageManagementData,
        patchPageManagementData,
        deletePageManagementData,
    };
};
export { usePageManagement };
